import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
} from "@mui/material";
import { useGet } from "../../../hooks/api-call";
import { Controller } from "react-hook-form";

const OrderSellerSection = ({ onChange, initialValue, control, errors }) => {
  const [selectedSeller, setSelectedSeller] = useState(initialValue || {});
  const { responseData: sellers } = useGet(`sellers`);

  const handleChange = (seller) => {
    const modifiedValue = {
      target: {
        name: "sellerId",
        value: seller.sellerId,
      },
    };
    setSelectedSeller(seller);
    onChange(modifiedValue);
  };

  const renderAddress = () => {
    if (!selectedSeller?.address) return "";
    return `${selectedSeller?.address || ""}, ${selectedSeller?.locality || ""}, ${selectedSeller?.district || ""}, ${selectedSeller?.state || ""}, ${selectedSeller?.pincode || ""}`;
  };

  return (
    <Box>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} md={4}>
          <FormControl fullWidth error={!!errors?.sellerId}>
            <InputLabel required>Mine Name</InputLabel>
            <Controller
              name="sellerId"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  label="Seller"
                  value={field.value || ""}
                  onChange={(e) => {
                    const sellerId = e.target.value;
                    const seller = sellers.find((seller) => seller.sellerId === sellerId); // Find the full seller object

                    field.onChange(sellerId);
                    handleChange(seller);
                  }}
                >
                  {sellers?.map((seller, index) => (
                    <MenuItem key={index} value={seller.sellerId}>
                      {seller?.mineName}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            {errors?.sellerId && (
              <FormHelperText>{errors.sellerId.message}</FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Company Name"
            fullWidth
            value={selectedSeller?.companyName || ""}
            disabled
            required
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="GST No"
            fullWidth
            value={selectedSeller?.gstNo || ""}
            disabled
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={4}>
          <TextField
            label="PAN No"
            fullWidth
            value={selectedSeller?.panNo || ""}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Contact No."
            fullWidth
            value={selectedSeller?.contactNo || ""}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="Email ID"
            fullWidth
            value={selectedSeller?.emailId || ""}
            disabled
          />
        </Grid>
      </Grid>

      <Box mt={3}>
        <TextField
          label="Delivery Address"
          fullWidth
          value={renderAddress()}
          disabled
        />
      </Box>
    </Box>
  );
};

export default OrderSellerSection;
